import { AVAILABLE_PAGES_ENUM, PAGES_ENUM } from 'routes/enums';
import { RouteMapType } from 'routes/routeGroupMaps/types';

const map: RouteMapType = new Map([
  [AVAILABLE_PAGES_ENUM.FIRMS_LIST, PAGES_ENUM.FIRMS_LIST],
  [AVAILABLE_PAGES_ENUM.FIRMS_DETAIL, PAGES_ENUM.FIRMS_LIST],
  [AVAILABLE_PAGES_ENUM.FIRM_MANAGERS, PAGES_ENUM.FIRMS_LIST],
]);

export default map;
